export default __webpack_public_path__ + "static/media/mt_portfolio-02.4665bb21.png";